/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import Icon from "./Icon";

export default class ViewFixed extends BaseCom {

    minimize = () => {
        let top = this.props.top;
        let left = this.props.left;
        let right = this.props.right;
        let bottom = this.props.bottom;




    }

    onMinimizeToggle = () => {
        this.setState({ minimized: !this.state.minimized });
    }

    render() {
        let style = this.props.style || {};


        style = {
            ...style,
            top: this.props.top || 'auto',
            left: this.props.left || 'auto',
            right: this.props.right || 'auto',
            bottom: this.props.bottom || 'auto',
            overflow: this.props.overflow || 'auto',
            width: this.props.width || 'auto',
            height: this.props.height || 'auto',
            zIndex: this.props.zIndex || 1000
        };

        if (this.state.minimized) {
            style.height = '2rem';
        }

        return (
            <div id={this.props.id} view-data="fixed" className={'position-fixed' + (this.props.className ? ' ' + this.props.className : '')}
                style={style}>
                {this.props.onClose && <div style={{ position: 'absolute', right: '0.5rem', top: '0' }} onClick={this.props.onClose}><Icon icon="faClose" /></div>}
                {this.props.minimize && <div style={{ position: 'absolute', right: '0.5rem', top: '0' }}
                    onClick={this.onMinimizeToggle}>
                    {this.state.minimized ? <Icon icon="faExpand" /> : <Icon icon="faMinus" />}
                </div>}
                {this.props.children}
            </div>
        )
    }
}